import React, {useEffect, useState} from 'react';
import {Button} from "@mui/material";
import Dropdown from "react-dropdown";
import { useTranslation } from "react-i18next";
import { generateTimeOptions } from "../../../utils/utilsFunc";

interface orderButtonsProps {
    // times: string[];
    acceptOrderHandle: (order: any) => void;
    selectedOrder: any;
    acceptTimeHandle: (time: any) => void;
    isDineIn: boolean;
    guests: string;
    setGuestsNr: (guests: string) => void;
    reserveName: string;
    setReserveName: (name: string) => void;
    weeklyPlan: any;
    timeStep: number;
}

const OrderButtons: React.FC<orderButtonsProps> = (props: orderButtonsProps) => {
    const { t } = useTranslation();
    const [showAcceptButton, setShowAcceptButton] = useState(false);
    const [selectedTime, setSelectedTime] = useState<string>();
    const [timeOptions, setTimeOptions] = useState<any[]>([]);
    
    const toggleAcceptButton = () => {
        setShowAcceptButton(true);
    }

    const acceptOrderHandler = () => {
        props.acceptOrderHandle(props.selectedOrder);
        props.acceptTimeHandle(selectedTime);
    }
    
    useEffect(() => {
        if (props.weeklyPlan) {
            const currentDay = new Date().toLocaleString('en-US', { weekday: 'long' }).toLowerCase();
            const timeRanges: any[] = props.weeklyPlan[currentDay] || [];
            
            setTimeOptions(generateTimeOptions(timeRanges, props.timeStep));
            console.log("weeklyPlan: ", props.weeklyPlan);
            console.log("timeRanges: ", timeRanges);
            console.log("timeOptions: ", generateTimeOptions(timeRanges, props.timeStep));
        }
    }, [props.weeklyPlan]);
    
    const handleTimeChange = (newTime: string) => {
        setSelectedTime(newTime);
        props.acceptTimeHandle(newTime);
    }

    useEffect(() => {
        props.acceptTimeHandle(selectedTime);
        console.log("selectedTime: ", selectedTime);
    }, [selectedTime]);

    return (
        <div className="orderButtons__container">
            <div className="orderButtons__container-wrap">
                <div className="orderButtons__container-wrap-button">
                    {
                        showAcceptButton ?
                            <div className="orderButtons__container-accept-wrap">
                                <div className="orderButtons__container-accept-time-pick-wrap">
                                    <div className="orderButtons__container-accept-time-pick-title">
                                        <span>{t('buttons.pickUpAt')}:</span>
                                    </div>
                                    <div className="orderButtons__container-accept-time-pick">
                                        <Dropdown
                                            className="orderButtons__container-accept-time-pick-dropdown"
                                            arrowClosed={
                                                <div className="orderButtons__container-accept-time-pick-dropdown-icon close">
                                                    <img src={process.env.PUBLIC_URL + "/images/pick-time-dropdown-icon-close.svg"} alt="arrow closed"/>
                                                </div>
                                            }
                                            arrowOpen={
                                                <div className="orderButtons__container-accept-time-pick-dropdown-icon open">
                                                    <img src={process.env.PUBLIC_URL + "/images/pick-time-dropdown-icon-close.svg"} alt="arrow open"/>
                                                </div>
                                            }
                                            options={timeOptions}
                                            onChange={(e) => handleTimeChange(e.value)}
                                            value={selectedTime}
                                        />
                                    </div>
                                </div>
                                <Button
                                    className="orderButtons__container-button-btn accept"
                                    variant="contained"
                                    onClick={acceptOrderHandler}
                                >
                                    <span>{t('buttons.accept')}</span>
                                </Button>
                            </div>
                            :
                            <>
                            {
                                props.isDineIn ? (
                                    <div className="orderButtons__container-dine-in-wrap">
                                        {
                                            timeOptions && timeOptions.length > 0 ? (
                                              <div className="orderButtons__container-dine-in">
                                                  <div className="orderButtons__container-accept-time-pick-dine-in">
                                                      <div className="orderButtons__container-accept-time-pick-wrap">
                                                          <div className="orderButtons__container-accept-time-pick-title">
                                                              <span>{t('buttons.pickUpAt')}:</span>
                                                          </div>
                                                          <div className="orderButtons__container-accept-time-pick">
                                                              <Dropdown
                                                                className="orderButtons__container-accept-time-pick-dropdown"
                                                                arrowClosed={
                                                                    <div className="orderButtons__container-accept-time-pick-dropdown-icon close">
                                                                        <img src={process.env.PUBLIC_URL + "/images/pick-time-dropdown-icon-close.svg"} alt="arrow closed"/>
                                                                    </div>
                                                                }
                                                                arrowOpen={
                                                                    <div className="orderButtons__container-accept-time-pick-dropdown-icon open">
                                                                        <img src={process.env.PUBLIC_URL + "/images/pick-time-dropdown-icon-close.svg"} alt="arrow open"/>
                                                                    </div>
                                                                }
                                                                options={timeOptions}
                                                                onChange={(e) => handleTimeChange(e.value)}
                                                                value={selectedTime}
                                                              />
                                                          </div>
                                                      </div>
                                                      <div className="orderButtons__container-dine-in-guests">
                                                          <label className="orderButtons__container-dine-in-guests-label" htmlFor="guests">{t('food.guests')}</label>
                                                          <div className="orderButtons__container-dine-in-guests-input">
                                                              <input
                                                                type="number"
                                                                id="guests"
                                                                name="guests"
                                                                min="1"
                                                                max="10"
                                                                value={props.guests}
                                                                onChange={(e) => props.setGuestsNr(e.target.value)}
                                                              />
                                                          </div>
                                                      </div>
                                                  </div>
                                                  <div className="orderButtons__container-dine-in-name">
                                                      <label className="orderButtons__container-dine-in-name-label" htmlFor="name">{t('auth.name')}</label>
                                                      <div className="orderButtons__container-dine-in-name-input">
                                                          <input
                                                            type="text"
                                                            id="name"
                                                            name="name"
                                                            value={props.reserveName}
                                                            onChange={(e) => props.setReserveName(e.target.value)}
                                                          />
                                                      </div>
                                                  </div>
                                              </div>
                                            ) : (
                                              <div className="orderButtons__container-accept-time-pick-title">
                                                  <span>{t('food.currentlyUnavailable')}</span>
                                              </div>
                                            )
                                        }
                                        <Button
                                            className="orderButtons__container-button-btn dine-in"
                                            variant="contained"
                                            onClick={acceptOrderHandler}
                                            disabled={!(selectedTime && props.reserveName !== '' && props.reserveName.length > 2 && props.guests && parseFloat(props.guests) > 0)}
                                        >
                                            <span>{t('buttons.reserve')}</span>
                                        </Button>
                                    </div>
                                ) : (
                                  <>
                                      <div className="orderButtons__container-accept-time-pick-wrap">
                                          <div className="orderButtons__container-accept-time-pick-title">
                                              <span>{t('buttons.pickUpAt')}:</span>
                                          </div>
                                          <div className="orderButtons__container-accept-time-pick">
                                              <Dropdown
                                                className="orderButtons__container-accept-time-pick-dropdown"
                                                arrowClosed={
                                                    <div className="orderButtons__container-accept-time-pick-dropdown-icon close">
                                                        <img src={process.env.PUBLIC_URL + "/images/pick-time-dropdown-icon-close.svg"} alt="arrow closed"/>
                                                    </div>
                                                }
                                                arrowOpen={
                                                    <div className="orderButtons__container-accept-time-pick-dropdown-icon open">
                                                        <img src={process.env.PUBLIC_URL + "/images/pick-time-dropdown-icon-close.svg"} alt="arrow open"/>
                                                    </div>
                                                }
                                                options={timeOptions}
                                                onChange={(e) => handleTimeChange(e.value)}
                                                value={selectedTime}
                                              />
                                          </div>
                                      </div>
                                      <Button
                                        className="orderButtons__container-button-btn take-out"
                                        variant="contained"
                                        onClick={acceptOrderHandler}
                                        disabled={!selectedTime}
                                      >
                                            <span>{t('buttons.yesPlease')}</span>
                                      </Button>
                                  </>
                                )
                            }
{/*                                <Button
                                    className="orderButtons__container-button-btn take-out"
                                    variant="contained"
                                    onClick={toggleAcceptButton}
                                >
                                    <span>
                                        take-out
                                    </span>
                                </Button>
                                <Button
                                    className="orderButtons__container-button-btn dine-in"
                                    variant="contained"
                                    onClick={toggleAcceptButton}
                                >
                                    <span>
                                        dine-in
                                    </span>
                                </Button>*/}
                            </>
                    }
                </div>
            </div>
        </div>
    );
};

export default OrderButtons;